module.exports = __webpack_public_path__ + "static/AzureADB2C-8f4de5cfa127f5bb6949a936215ad073.png";